import { useCallback, useEffect, useState } from "react";
import { API_BASE, apiFetch } from "../api";

// The budgets table for the desktop pages (the phone screens get it from
// useMobileData). `create` / `update` / `remove` take the collection name first, like
// useMobileData's, so the same budget components work with either.
export const useBudgets = () => {
  const [budgets, setBudgets] = useState([]);

  const reload = useCallback(
    () =>
      apiFetch(`${API_BASE}/budgets`)
        .then((res) => (res.ok ? res.json() : Promise.reject()))
        .then(setBudgets)
        .catch(() => {}),
    []
  );

  useEffect(() => {
    reload();
  }, [reload]);

  const send = async (method, id, body) => {
    const res = await apiFetch(`${API_BASE}/budgets${id ? `/${id}` : ""}`, {
      method,
      headers: { "Content-Type": "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || "Something went wrong.");
    }
    await reload();
  };

  return {
    budgets,
    reload,
    create: (_collection, body) => send("POST", null, body),
    update: (_collection, id, body) => send("PATCH", id, body),
    remove: (_collection, id) => send("DELETE", id),
  };
};
